import { Editor } from 'tinymce';

// If `rng` partially overlaps a dynamic entry span (starts or ends inside one without
// covering it fully), grows it so the whole span is included. Returns the same range
// instance when no span needs to be pulled in, so callers can skip a no-op setRng.
export function expandRangeToFullTokens(ed: Editor, rng: Range): Range {
	// The editor root itself carries a data-id, so it must be excluded explicitly - same
	// caveat as getDynamicSpanAtCursor.
	const spans = ed.dom.select('[data-id]:not(#tinymce)');

	let startContainer = rng.startContainer;
	let startOffset = rng.startOffset;
	let endContainer = rng.endContainer;
	let endOffset = rng.endOffset;
	let changed = false;

	for (const span of spans) {
		const spanRng = ed.dom.createRng();
		spanRng.selectNode(span);

		// isPointInRange is inclusive of both ends, so also check the point isn't already
		// exactly on the matching boundary - otherwise every fully-covered/untouched span
		// would still (harmlessly, but needlessly) mark the range as changed.
		if (
			spanRng.isPointInRange(startContainer, startOffset) &&
			!(startContainer === spanRng.startContainer && startOffset === spanRng.startOffset)
		) {
			startContainer = spanRng.startContainer;
			startOffset = spanRng.startOffset;
			changed = true;
		}

		if (
			spanRng.isPointInRange(endContainer, endOffset) &&
			!(endContainer === spanRng.endContainer && endOffset === spanRng.endOffset)
		) {
			endContainer = spanRng.endContainer;
			endOffset = spanRng.endOffset;
			changed = true;
		}
	}

	if (!changed) return rng;

	const expanded = ed.dom.createRng();
	expanded.setStart(startContainer, startOffset);
	expanded.setEnd(endContainer, endOffset);
	return expanded;
}
